export default class ReleaseNoteUtils {
  public static sortByReleaseDate(arr: ReleaseNote[], order: "asc" | "desc" = "desc") {
  return arr.sort((a, b) => {
    const dateA = new Date(a.releaseDate).getTime();
    const dateB = new Date(b.releaseDate).getTime();
    
    return order === "asc" ? dateA - dateB : dateB - dateA;
  });
};
}